import { render, staticRenderFns } from "./item_link.vue?vue&type=template&id=1b2433c9&scoped=true&"
import script from "./item_link.vue?vue&type=script&lang=js&"
export * from "./item_link.vue?vue&type=script&lang=js&"
import style0 from "./item_link.vue?vue&type=style&index=0&id=1b2433c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2433c9",
  null
  
)

export default component.exports